import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { ButtonType } from '@pxl/models/common';
import { AccountRoutingRouteNames, AppRoutingRouteNames } from '@pxl/route-names';
import { RESOURCES } from '@pxl/shared/translation';

import { GeneralErrorData } from '../models/general-error.models';

/**
 * Error page data for an invalid/expired external health record email link. The visitor is an
 * unregistered pet owner, so it offers registration and login instead of dashboard navigation.
 */
export const resolveInvalidEmailLinkErrorPageData: ResolveFn<GeneralErrorData> = () => {
    const router = inject(Router);
    const resourceKeys = RESOURCES.petsxl.ui.external_health_record_landing;

    return {
        title: resourceKeys.errors.invalid_link.headline,
        message: resourceKeys.errors.invalid_link.message,
        buttons: [
            {
                label: resourceKeys.actions.register,
                type: ButtonType.primary,
                action: () => router.navigate([AppRoutingRouteNames.SignIn, AccountRoutingRouteNames.SignUpRegistration]),
            },
            {
                label: RESOURCES.petsxl.ui.page_not_found.actions.login,
                type: ButtonType.secondary,
                action: () => router.navigate([AppRoutingRouteNames.SignIn]),
            },
        ],
        pageHeaderIllustration: 'error-message',
    };
};
